export default function LabeledDate(el) {
  el.toggleAttribute("data-has-value", (el.value || "").trim())

  el.addEventListener("change", () => {
    el.toggleAttribute("data-has-value", !!(el.value || "").trim())
  })
}
